import React from 'react';
import { Modal } from 'react-bootstrap';
import styles from './DeactivateStaffModal.css';

class DeactivateStaffModal extends React.Component {
  render() {
    const {
      show,
      onCancel,
      onDeactivate,
      employeeDetail,
      errorMessage,
    } = this.props;
    const employeeName = employeeDetail
      ? `${employeeDetail.first_name} ${employeeDetail.last_name}`
      : '';
    return (
      <Modal
        show={show}
        onHide={() => {}}
        dialogClassName={`modal-dialog ${styles.dialog}`}
      >
        <Modal.Header bsClass={`modal-header ${styles.header}`}>
          <Modal.Title className={styles.title}>
            Deactivate Employee
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className={styles.dialogBody}>
          {!errorMessage ? (
            <div>
              Deactivating an employee will remove them from this slot. You can
              assign other employees to this slot after you deactivate them.
              <br />
              Are you sure you want to deactivate <b>{employeeName}</b> ?{' '}
            </div>
          ) : (
            errorMessage
          )}
        </Modal.Body>
        <Modal.Footer>
          <span className={styles.right}>
            <button onClick={onCancel} className="btn btn-default">
              Cancel
            </button>
            {!errorMessage && (
              <button onClick={onDeactivate} className="btn btn-danger">
                Deactivate Employee
              </button>
            )}
          </span>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default DeactivateStaffModal;
